import { TagComponent } from "@pineseed/gui/component/tag";
import { InvalidTag } from "@pineseed/gui/component/invalid-tag";
import { Tag } from "@pineseed/gui/types";
// import { useTags } from "../hooks/useTags";

interface TextWithTagsProps {
  text: string;
  tagSize?: "sm" | "md" | "lg";
  className?: string;
  useTags: () => {
    parseTextWithTags: (text: string) => { 
      type: "text" | "valid-tag" | "invalid-tag" | "escaped-at"; 
      content: string; 
      tag?: Tag 
    }[];
    extractTagNameForDisplay: (content: string) => string;
  };
}

/**
 * TextWithTags Component
 * STRICT ARCHITECTURE COMPLIANCE: Pure UI only
 * - No business logic (moved to TagHandler.parseTextWithTags)
 * - Only renders UI based on parsed segments from handler
 * - All logic delegated to handler via useTags hook
 */
export function TextWithTags({
  text,
  useTags,
  tagSize = "sm",
  className,
}: TextWithTagsProps) {
  const { parseTextWithTags, extractTagNameForDisplay } = useTags();

  // Pure UI: Get parsed segments from handler via hook
  const segments = parseTextWithTags(text);

  return (
    <span className={className}>
      {segments.map((segment, index) => {
        switch (segment.type) {
          case "valid-tag":
            return segment.tag ? (
              <TagComponent
                key={`valid-${index}`}
                tag={segment.tag}
                size={tagSize}
                variant="outline"
                interactive={false}
                className="mx-0.5"
              />
            ) : null;

          case "invalid-tag": {
            // Pure UI: Get display name from handler
            const tagName = extractTagNameForDisplay(segment.content);

            return (
              <InvalidTag
                key={`invalid-${index}`}
                name={tagName}
                size={tagSize}
                className="mx-0.5"
              />
            );
          }

          case "escaped-at":
            return <span key={`escaped-${index}`}>{segment.content}</span>;

          case "text":
          default:
            return (
              <span key={`text-${index}`} style={{ whiteSpace: "pre-wrap" }}>
                {segment.content}
              </span>
            );
        }
      })}
    </span>
  );
}
